import { render, staticRenderFns } from "./htmlList.vue?vue&type=template&id=ef657570"
import script from "./htmlList.vue?vue&type=script&lang=js"
export * from "./htmlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports